











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {MotoristaResponsavel} from '@/model/resource/MotoristaResponsavel'
import {MotoristaResponsavelCollection} from '@/model/collection/MotoristaResponsavelCollection'
import {ListMotoristaResponsavelSchema} from '@/schema/resource/MotoristaResponsavel/ListMotoristaResponsavelSchema'
import {CsvMotoristaResponsavelSchema} from '@/schema/resource/MotoristaResponsavel/CsvMotoristaResponsavelSchema'

@Component
export default class ListMotoristaResponsavelView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListMotoristaResponsavelSchema()
  collection = new MotoristaResponsavelCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: MotoristaResponsavel) {
    Helper.pushByName(
      'editMotoristaResponsavel',
      item.idMotoristaFk,
      item.idResponsavelFk
    )
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new MotoristaResponsavelCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvMotoristaResponsavel()
    new CsvMotoristaResponsavelSchema().downloadCsv(csv.all())
  }
}
